<template>
    <div class="com-part1">
		<title1 type="1" title="高负载服务器" style="margin-top: 30px" />
        <div class="sub-title flex justify-end align-center">
            <div
                v-for="(item, i) in subTitle" :key="'subTitle' + i"
                @click="subTitleChange(item.label,i)">
                <p :class="{'at': i == subTitleAt}">{{ item.label }}</p>
            </div>
        </div>
        <div class="p-content">
			<div
				v-for="(item, i) in loadList"
				:key="'loadList' + i"
				class="load-list">
				<div class="flex item-t">
					<div class="icon-bg flex justify-center align-center">{{ i + 1 }}</div>
					<div class="hostIp">{{ item.hostIp }}</div>
				</div>
				<div class="flex item-b  align-center">
					<div class="flex1 item-l">
						<div class="solid" :style="{'width': `${item.loadValue}%`}"></div>
					</div>
					<div class="flexs flex justify-center item-r">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ Number(item.loadValue).toFixed(0) }}% </div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
// import myEchart from "./charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi"
import { formatTime } from '@/utils/index'
export default {
    components: {
        title1,
        // myEchart
    },
    data() {
        return {
            subTitle: [
                {
                    label: 'GPU'
                },
                {
                    label: 'CPU'
                },
                {
                    label: '内存'
                },
                {
                    label: '存储'
                }
            ],
            subTitleAt: 0,
			loadList: [
				{
					hostIp: '123123123123',
					loadValue: 80
				},
				{
					hostIp: '123123123',
					loadValue: 80
				},
				{
					hostIp: '2131231',
					loadValue: 80
				},
				{
					hostIp: '123123',
					loadValue: 80
				},
				{
					hostIpip: '123123123',
					loadValue: 40
				}
			],
			index: -1,
			timer: null
        }
    },
	mounted(){
		
    },
	created(){
		this.subTitleChange()
		this.timer = setInterval(()=>{
            if(this.index == 3) this.index = -1
            this.index++
            this.subTitleChange(this.subTitle[this.index].label,this.index)
        },5000)
	},
	methods: {
        // 副标题切换
        subTitleChange(label = 'GPU',i) {
            this.subTitleAt = i || 0
			this.selectComprehensiveSituation(label)
        },
		selectComprehensiveSituation(label){ 
            let _this = this;
            let params = { 
                enCode: 'computingpower-left-gfzfwq',
				'@types': label
            }
            dataInterface
            .dataFaceApi(params)
            .then((res) => {
                if(!res) return;
				if(label == '内存'){
					this.loadList = res.map(item=>{
						return {loadValue:item.loadValue / 1024 * 100,hostIp:item.hostIp}
					})
				}else{
					this.loadList = res || []
				}
    
				console.log(this.loadList,'高负载服务器1213')
            })
            .catch((err) => {
                console.log(err);
            });
        }
    },
    destroyed () {
        console.log('destroyed')
        clearInterval( this.timer )
    },
}
</script>

<style lang="scss" scoped>
@import '../comm.scss';
.com-part1 {
    width: 100%;
    height: 843px;
    .sub-title {
        font-size: $FontSize28;
        padding-top: 20px;
        height: 50px;
        > div {
            padding-right: 20px;
            > p {
                text-shadow: 0px 0px 9px #03B9BD;
                padding: 0 10px;
                position: relative;
                cursor: pointer;
                &.at {
                    &::after {
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                        content: '';
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(270deg, rgba(113, 186, 188, 0.0001) 0%, #71BBBD 33.33%, #6DB5B7 66.67%, rgba(111, 185, 187, 0.0001) 100%);
                    }
                }
            }
        }
    }

    .p-content {
        width: 100%;
        height: 843px;
		padding: 0 10px;
		box-sizing: border-box;
		.load-list {
			font-size: $FontSize24;
			margin: 40px 0;
			.item-t {
				.icon-bg {
					width: 36px;
					height: 42px;
					background: url(~@/assets/images/computility/dispatch-icon6.png) center no-repeat;
					background-size: 100%;
					padding-bottom: 6px;
					box-sizing: border-box;
					font-size: $FontSize20;
					margin-right: 20px;
				}
				.hostIp{
					font-size: $FontSize28;
				}
			}
			.item-b {
				height: 50px;
				.item-l {
					height: 35px;
					background-color: rgba(208, 222, 238, 0.1);
					.solid {
						background: linear-gradient(270deg, #1FFAFF 1.64%, #E2FFFD 100%);
						position: relative;
						height: 32px;
						&::before {
							position: absolute;
							content: '';
							background-color: #fff;
							box-shadow: 0px 0px 4px 0px #EFD48E;
							width: 37px;
							height: 37px;
							right: -9px;
							top: -3px;
							border-radius: 50%;
						}
					}
				}
				.item-r {
					width: 80px;
					font-size: $FontSize28;
				}
			}
		}
    }
}
</style>